import commonReducer from "../store/slices/common";
import LoaderReducer from "../store/slices/loader";

const rootReducers = {
  common: commonReducer,
  loader: LoaderReducer,
};

export default rootReducers;
